<template>
  <el-button type="primary" plain class="subscriptionform-elbtn" @click="onClickThisButton">{{ ButtonTextName }}</el-button>
</template>

<script>
export default {
  props: {
    ButtonTextName: String,
    onClick: Function
  },
  methods: {
    onClickThisButton() {
      this.onClick()
    }
  }
}
</script>